import { AlertTitle as ChakraAlertTitle, AlertTitleProps as ChakraAlertTitleProps } from '@chakra-ui/react';
import { specialFont } from 'constants/theme';

const AlertTitle = (props: ChakraAlertTitleProps) => (
  // Workaround for styles not supported
  <ChakraAlertTitle fontFamily={specialFont} letterSpacing="wide" {...props} />
);

export { AlertTitle };
